import {
  Notification,
  NOTIFICATION_TYPE_ENUM,
} from '../definitions/notifications';
import C from '../constants';

const parseNotifications = (notifications: Notification[]) =>
  notifications.map(notification => ({
    ...notification,
    permalink:
      notification.type === NOTIFICATION_TYPE_ENUM.CHAT &&
      notification.entityType &&
      notification.entityType === 'supplier'
        ? `/supplier/${notification.entityId}/inbox`
        : notification.permalink,
  }));

export default (
  state = {
    count: 0,
    notifications: [],
    payload: {},
    unread: 0,
    searchedNotifications: [],
  },
  action
) => {
  switch (action.type) {
    case C.FETCH_USER_NOTIFICATIONS_REQUEST:
    case C.SEARCH_USER_NOTIFICATIONS_REQUEST: {
      return { ...state, loading: true };
    }
    case C.CLEAR_NOTIFICATIONS_PAYLOAD:
      return {
        ...state,
        payload: {},
      };
    case 'NOTIFY_WEBSOCKET_MESSAGE_SUCCESS': {
      const { data } = action;
      return {
        ...state,
        payload: data,
      };
    }
    case C.RECEIVE_NOTIFICATIONS_SUCCESS:
    case C.FETCH_USER_NOTIFICATIONS_SUCCESS: {
      const { data } = action;

      return {
        ...state,
        unread: data.meta.unread,
        count: data.meta.totalResults,
        loading: false,
        notifications: parseNotifications(data.data),
      };
    }
    case C.SEARCH_USER_NOTIFICATIONS_SUCCESS: {
      const { data } = action;
      if (data?.meta?.pageNo > 1) {
        return {
          ...state,
          unread: data.meta.unread,
          count: data.meta.totalResults,
          loading: false,
          searchedNotifications: [
            ...parseNotifications(data.data),
            ...state.searchedNotifications,
          ],
        };
      }
      return {
        ...state,
        unread: data.meta.unread,
        count: data.meta.totalResults,
        loading: false,
        searchedNotifications: parseNotifications(data.data),
      };
    }
    case C.RECEIVE_TOKEN_SUCCESS: {
      return { ...state, token: action.token };
    }
    case C.CLICK_TOAST: {
      return {};
    }
    default:
      return state;
  }
};
